import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ExpeditionProcessFormContainer from "../expeditionProcessForm/expeditionProcessForm.container";

export const useExpedition = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const onSuccess = () => {
    if (refresh) {
      refresh();
    }
    handlerClosePopup("ModalForm");
  };

  const createInventary = async (data) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-1">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row justify-content-center mb-3">
              <div className="col-12">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handlerClosePopup("ModalForm");
                    // navigate(`/resultados?start=${startDate}&end=${endDate}`);
                  }}
                >
                  <div className="mb-3">
                    <label>{t("forms.inventary.labels.dateInit")}</label>
                    <input
                      type="date"
                      name="startDate"
                      className="form-control"
                      required
                    />
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handlerClosePopup("ModalForm")}
                  >
                    {t("forms.inventary.labels.cancel")}
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {t("forms.inventary.labels.save")}
                  </button>
                </form>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const newExpedition = async (service, uuid) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-1">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row justify-content-center mb-3">
              <div className="col-12">
                <ExpeditionProcessFormContainer
                  data={service}
                  onSuccess={() => onSuccess()}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  uuid={uuid}
                />
              </div>
            </div>
          </>
        ),
      })
    );
  };

  return {
    createInventary,
    newExpedition,
  };
};
